export enum PartyType {
    PERSON = 'person',
    COMPANY = 'company',
    FOREIGNER = 'foreigner',
}
